// Component: serviceTypeReducer
// Description: Reducer for handling service type

const initialState = {
    assetType: "",
    category: ""
};

const serviceTypeReducer = (state = initialState, action) => {

    switch (action.type) {
        case "SERVICE_TYPE":
            return {
                ...state,
                assetType: action.payload
            }

        case "SERVICE&CATEGORY_TYPE":

            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
};

export default serviceTypeReducer;